export class PublicationOptions {
  public flash:boolean = false;
}